import { OrderApi } from '@/api/order.api';
import { Order } from '@/models/order.model';
import { LoadingService } from '@/services/loading.service';
import { Util } from '@/utils/util';
import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

export interface DialogData {
  title: string;
  orderId: string;

  saveButtonLabel: string;
  cancelButtonLabel: string;

  rightButtonText: string;
  leftButtonText: string;
}

@Component({
  selector: 'app-dialogOrder',
  templateUrl: './dialogOrder.component.html',
  styleUrls: ['./dialogOrder.component.scss'],
})
export class DialogOrderComponent {
  order!: Order;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogOrderComponent>,
    private orderApi: OrderApi,
    private loadingService: LoadingService,
    private utilService: Util
  ) {
    this.getOrderById();
  }

  getOrderById() {
    this.loadingService.show();
    this.orderApi.getOrderById(this.data.orderId).then((order) => {
      this.order = order;
      this.loadingService.hide();
    });
  }

  formatDate(isoDate: string): string {
    return this.utilService.formatDate(isoDate);
  }

  formatCurrency(currency: number) {
    return this.utilService.convertCurrencyToBRL(currency);
  }

  onRightButton() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
